import { render, staticRenderFns } from "./SelectBoxForm.vue?vue&type=template&id=f4d4df3c&scoped=true&"
import script from "./SelectBoxForm.vue?vue&type=script&lang=js&"
export * from "./SelectBoxForm.vue?vue&type=script&lang=js&"
import style0 from "./SelectBoxForm.vue?vue&type=style&index=0&id=f4d4df3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d4df3c",
  null
  
)

export default component.exports